import { useContext, useLayoutEffect, useRef } from 'react'
import { DataModVerContext } from 'components/SectionHandler/components/ItemView'

/*
	this components sets formState.values to the current initialValues if mod_ver changed
*/
const useModVerRemount = ({ reinitByModVer, formApi, initialValues }) => {
	const mod_ver = useContext(DataModVerContext)
	const oldModVer = useRef(mod_ver)

	useLayoutEffect(() => {
		if(oldModVer.current !== mod_ver && reinitByModVer) {
			if(mod_ver >= oldModVer.current) {
				formApi.setValues(initialValues)
			}
			oldModVer.current = mod_ver
		}
	}, [mod_ver])		// eslint-disable-line react-hooks/exhaustive-deps
}

export default useModVerRemount
